export const CONNECTION_TIMEOUT = 10000;
export const UPDATE_TIMEOUT = 10000;
export const MAX_RETRIES = 3;
export const RETRY_DELAY = 2000;
